import { useEffect, useRef } from 'react';

/**
 * Google AdSense slot wrapper.
 *
 * Props:
 *  - adSlot:    your ad unit slot ID (e.g. "1234567890")
 *  - adFormat:  "auto" | "horizontal" | "rectangle" | "vertical" (default: "auto")
 *  - className: optional extra classes for the outer wrapper
 *  - style:     optional style overrides for the <ins> element
 */
export default function AdSlot({
  adSlot = '',
  adFormat = 'auto',
  fullWidthResponsive = true,
  className = '',
  style = {},
}) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
        pushed.current = true;
      }
    } catch {
      // AdSense not loaded or blocked
    }
  }, []);

  return (
    <aside
      className={`ad-slot no-print ${className}`}
      aria-label="Advertisement"
      style={{ textAlign: 'center' }}
    >
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          ...style,
        }}
        data-ad-client="ca-pub-4958360574877314"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive}
      />
    </aside>
  );
}
